module.exports = __webpack_public_path__ + "img/meh.a513efb2.svg";